const themeTypes = {
  TOGGLE: 'theme/toggle',
  SET: 'theme/set',
};

export default themeTypes;
